export class LocalDateUtility {

  /**
   * Generates a text representation of a Java LocalDate for the given year and month.
   * @param year the year
   * @param month the month
   */
  static generateLocalDateFormattedValue(year: number, month: number): string {
    /**
     * Ensure that the month is two digits.
     */
    const formattedMonth = month < 10 ? `0${month}` : `${month}`;
    /**
     * Use the first second of the first day of the month.
     */
    return `${year}-${formattedMonth}-01`;
  }
}
